<template>
  <img data-title="logo" src="../../img/Hill_Universe.png" class="w-[320px] h-[320px]" />
</template>

<script>
export default {
  name: "Logo"
}
</script>
